import type { User } from "firebase/auth";
import { authFetch } from "./auth-fetch";

async function ensureUserRecord(): Promise<void> {
	await authFetch("/api/users/init", { method: "POST" });
}

async function seedNameFromGoogle(user: User): Promise<void> {
	if (!user.displayName) return;
	const data = await authFetch("/api/settings/profile").then((r) => r.json());
	if (!data.name) {
		await authFetch("/api/settings/profile", {
			method: "PATCH",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ name: user.displayName }),
		});
	}
}

export function initNewUser(user: User): void {
	ensureUserRecord()
		.then(() => seedNameFromGoogle(user))
		.catch(() => {});
}
